import { useState, useEffect } from "react";
import { BarChart3, FileText, Truck, ArrowLeftRight, ScanLine } from "lucide-react";
import { Overview } from "./Overview";
import { Invoices } from "./Invoices";
import { DeliveryNotes } from "./DeliveryNotes";
import { Transactions } from "./Transactions";
import { Receipts } from "./Receipts";
import { InvoiceSheet } from "./InvoiceSheet";
import { DeliveryNoteSheet } from "./DeliveryNoteSheet";
import { MonthlyReport } from "./MonthlyReport";

const SUBTABS = [
  { key: "overview", label: "Übersicht", icon: BarChart3 },
  { key: "invoices", label: "Rechnungen", icon: FileText },
  { key: "delivery", label: "Lieferscheine", icon: Truck },
  { key: "transactions", label: "Ein-/Ausgaben", icon: ArrowLeftRight },
  { key: "receipts", label: "Belege", icon: ScanLine },
];

export const Accounting = ({ isAdmin = true }) => {
  const [sub, setSub] = useState("overview");
  const [printDoc, setPrintDoc] = useState(null);
  const [overviewKey, setOverviewKey] = useState(0);

  useEffect(() => {
    if (!printDoc) return;
    const close = () => setPrintDoc(null);
    window.addEventListener("afterprint", close);
    return () => window.removeEventListener("afterprint", close);
  }, [printDoc]);

  const triggerPrint = (doc) => {
    setPrintDoc(doc);
    setTimeout(() => window.print(), 400);
  };

  return (
    <div data-testid="accounting-view">
      <div className="flex flex-wrap gap-2 mb-8" data-testid="accounting-subtabs">
        {SUBTABS.map((t) => (
          <button
            key={t.key}
            data-testid={`acct-sub-${t.key}`}
            onClick={() => setSub(t.key)}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-display text-xs font-medium border transition-colors duration-200 ${
              sub === t.key ? "bg-[#e2001a] border-[#e2001a] text-white" : "border-white/20 text-white/60 hover:text-white"
            }`}
          >
            <t.icon size={13} /> {t.label}
          </button>
        ))}
      </div>

      {sub === "overview" && <Overview key={overviewKey} onPrintReport={(data) => triggerPrint({ type: "report", data })} />}
      {sub === "invoices" && <Invoices canConvert={isAdmin} onPrint={(inv) => triggerPrint({ type: "invoice", data: inv })} />}
      {sub === "delivery" && <DeliveryNotes onPrint={(n) => triggerPrint({ type: "delivery", data: n })} />}
      {sub === "transactions" && <Transactions onChanged={() => setOverviewKey((k) => k + 1)} />}
      {sub === "receipts" && <Receipts />}

      {printDoc && (
        <div className="print-overlay">
          {printDoc.type === "invoice" && <InvoiceSheet invoice={printDoc.data} />}
          {printDoc.type === "delivery" && <DeliveryNoteSheet note={printDoc.data} />}
          {printDoc.type === "report" && <MonthlyReport {...printDoc.data} />}
        </div>
      )}
    </div>
  );
};
